import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,[_c(VContainer,[_c(VCard,{staticClass:"mx-auto pa-5",attrs:{"max-width":"900"}},[_c(VCardTitle,[_vm._v(" Comments / Suggestions / Help Request ")]),_c(VContainer,[_c('contact-form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }